<template>
  <v-dialog v-model="dialog" width="1200" content-class="dialog-reject-item">
    <v-card style="overflow-x: scroll;">
      <v-list >
        <v-list-item style="display: flex; width: 100%; justify-content: end; padding: 20px 20px 0px 20px;" >
          <v-list-item-title style="font-size: 18px; font-weight: bold;">Vincular Item</v-list-item-title>
          <v-btn 
            @click="$emit('close')"
            style="display: flex; background-color: transparent; justify-self: center; margin-right: 12px;"
          >
            Cancelar
          </v-btn>
          <v-btn 
            style="display: flex; background-color: blue; align-self: end; justify-self: end; margin-bottom: 6px; color: white !important;"
            @click="$emit('link', selectedItem[0], purchaseOrder)"
            :disabled="selectedItem.length === 0"
          >
            Vincular <v-icon style="margin-left: 4px;">mdi-check</v-icon>
          </v-btn>
        </v-list-item>
      </v-list>
      <v-data-table
        :headers="headers"
        :items="items"
        hide-default-footer
        v-model="selectedItem"
        single-select
        show-select
        item-key="_id"
        class="elevation-1 mt-10"
      ></v-data-table>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';

export default {
  name: 'RecebimentoDeNotaFiscalVincularPedidoModal',
  props: {
    value: Boolean,
    linkedItem: Object,
    pedidoCompra: String
  },
  data() {
    return {
      isFormValid: false,
      selectedItem: [],
      purchaseOrder: '',
      items: [],
      headers: [
        { text: "Seq", value: "sequencia" },
        { text: "Descrição", value: "descricao" },
        { text: "Cód. Item", value: "itemCodigo" },
        { text: "Unidade", value: "unidadeSigla" },
        { text: "Quantidade", value: "quantidade" },
        { text: "Quantidade Entregue", value: "quantidadeEntregue" },
        { text: "Status", value: "status" }
      ]
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val); // Emite evento para atualizar o estado do modal
      }
    },
    themeClass() {
      return this.$vuetify.theme.dark ? 'dark-theme' : 'light-theme';
    },
  },
  methods: {
    async getPurchaseOrder() {
      const requestData = {
        params: [
          {
            name: "pedido",
            dataType: "String",
            value: this.purchaseOrder
          }
        ],
        viewName: "get-pedido-compra-nf-recebimento",
        page: 1,
        limit: 1
      };

      try {
        const response = await Vue.prototype.$http.post('/View/run', requestData);

        if (response && response.data) {
          console.log(response.data.data.data)
          this.items = response.data.data.data[0].itens

        } else {
          console.warn("A resposta da API não contém dados esperados:", response);
        }

      } catch (error) {
        this.items = []
        console.error("Erro ao carregar os dados do PGP:", error);
      }
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.$nextTick(async () => {
          this.purchaseOrder = this.pedidoCompra || '';

          if (this.linkedItem) {
            this.selectedItem = [this.linkedItem];
          } else {
            this.selectedItem = [];
          }

          if (this.purchaseOrder) {
            await this.getPurchaseOrder();
          } else {
            this.items = [];
          }
        });
      }
    }
  }
};
</script>
  
<style scoped>

    .style-i {
        color: white;
        font-size: 22px;
    }
    /*
    .style-i:hover {
        color: white;
    }*/

    .item-content {
        border-bottom: 1px solid rgba(172, 168, 168, 0.719);
    }

    a {
        color: black;
        margin-left: 5px;
        color: black;
    }


    span {
        float: right;
        font-size: 10px;
    }
    .card-item{
        position: relative;
    }

    .card-item:hover {
        cursor: pointer;
        background-color: whitesmoke;
    }

    .btn-aprovar, .btn-enviar-obs {
        background-color: green;
        border-radius: 15px;
        padding: 6px;
        color: white;
        font-size: 12px;
        margin: 0px 8px;
    }

    .btn-aprovar:hover, .btn-enviar-obs:hover {
        background-color: white;
        border: 1px solid green;
        color: green;
    }

    .btn-reprovar, .btn-cancelar-obs {
        background-color: red;
        border-radius: 15px;
        padding: 6px;
        color: white;
        font-size: 12px;
        margin: 0px 8px;
    }

    .btn-reprovar:hover, .btn-cancelar-obs:hover {
        background-color: white;
        border: 1px solid red;
        color: red;
    }

    .obs-container {
        margin-top: 3px;
        border: 1px solid #c5c0c0;
        padding: 5px;
    }

    .span-enviado {
        position: absolute;
        right: 15px;
        bottom: 2px;
    }

    .v-list-item__content{
        padding: 0px;
        max-height: 75px;
    }

  .img {
    margin: auto;
  }
  
  .card {
    margin-left: 500px;
  }
  
  .v-btn {
    margin-top: 15px;
  }
  
  .dialog-sobre {
    width: 500px !important;
  }
  
  .v-dialog__content {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;
    width: 100%;
    z-index: 6;
    outline: none;
  }

  .checkbox {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  
  .v-text-field--outlined fieldset {
    border: 0;
    border-bottom: 1px solid black;
    border-radius: 0;;
  }

  .v-text-field--outlined .v-text-field__slot {
    align-items: end !important;
  }

  .v-text-field .v-input__slot {
    padding: 0 !important;
  }

  .filterInputDate {
    outline: none;
    border: 1px solid #666;
    border-radius: 4px;
    width: 269px;
    padding-left: 10px;
    font-size: 12px;
    height: 40px;
  }

  .filterInput {
    width: 30%;
    text-decoration: none !important;
    border: none !important;
  }

  .theme--dark.v-list {
    background-color: #1e1e1e;
  }

  .v-sheet.v-stepper {
    border-radius: 0px;
  }

  .theme--dark.v-card {
    background-color: #1e1e1e;
  }

  .v-data-table-header {
    border-radius: 12px;
  }

  .v-btn[data-v-4b1b6f7c] {
    margin-top: 0px;
  }
  
  .v-stepper__header {
    box-shadow: none !important;
  }

  .v-stepper__content {
    padding: 0px 24px 16px 24px;
  }

  .theme--dark.tabsBg{
    background-color: #1e1e1e !important;
  }

  .checkbox-label ::v-deep(.v-label) {
    font-size: 16px; /* Aumente o tamanho conforme necessário */
    /* font-weight: bold; Opcional: deixa a fonte mais destacada */
  }
</style>
  